import Banner from "./Banner";
import Founders from "./Founders";  
import Team from "./Team";
import Management from "./Management";



const MeetOurTeam = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Team language={language} />
      <Founders language={language} />
      <Management  language={language} />
     
    </>
  );
};

export default MeetOurTeam;